/**
 */

"use strict";

/** CSS imports */
require("./css/style.css");
require("./css/jjsonviewer.css");

require("./lib/jquery.line.js");
require("./lib/fastClick.js");

/**
 * This is a hacky shim to get node-schedule to not error.
 * node-schedule is not designed to run in the browser and originally some
 * jerk manually removed the code out of the dependency so that it would
 * "just work" once deployed.
 */
if (!process.versions) process.versions = {};
process.versions.node = process.versions.node || "1.0.0";
const schedule = require("node-schedule");
const xss = require("xss");
const kdclient = require("./client");

/* Components */
const conf = require("./config");
const layout = require("./components/layout");
const modal = require("./components/modal");
const notification = require("./components/notification");
const login = require("./components/login");
const print = require("./components/print");

/* Controllers */
const ctrl_loading = require("./controllers/loading");
const ctrl_location = require("./controllers/location");
const ctrl_localization = require("./common").localization;
const ctrl_rpc = require("./controllers/rpc");
const ctrl_timezone = require("./controllers/timezone");
const ctrl_init = require("./controllers/init");
const ctrl_func = require("./controllers/func");
const ctrl_chart = require("./controllers/chart");
const ctrl_header = require("./controllers/header");
const ctrl_tabs = require("./controllers/tabs");
const ctrl_waitlist = require("./controllers/waitlist");
const ctrl_reservation = require("./controllers/reservation");
const ctrl_noshows = require("./controllers/noshows");
const ctrl_resnoshows = require("./controllers/resnoshows");
const ctrl_precheck = require("./controllers/precheck");
const ctrl_seated = require("./controllers/seated");
const ctrl_notes = require("./controllers/notes");
const ctrl_stats = require("./controllers/stats");
const ctrl_directseat = require("./controllers/directseat");
const ctrl_sections = require("./controllers/sections");
const ctrl_filter = require("./controllers/filter");
const ctrl_gestures = require("./controllers/gestures");
const ctrl_connection = require("./controllers/connection");
const ctrl_configuration = require("./controllers/configuration");
const ctrl_dashedit = require("./controllers/dashedit");
const ctrl_offline = require("./controllers/offline");
const ctrl_keyboard = require("./controllers/keyboard");
const ctrl_wizard = require("./controllers/wizard");
const ctrl_android = require("./controllers/android");
const ctrl_aux = require("./controllers/auxx");

let kd;

const xenialCompanyID = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  const decoded = JSON.parse(window.atob(base64));
  return decoded.company_id;
};

/**
 * Controllers configure
 * @param {Object} kd - the intialized kd library
 */
const configure = (kdObj) => {
  kd = kdObj;
  kd.setMaxListeners(35);
  kd.on("ready", (data) => {
    console.log(`kd ready! v${conf.vars.VERSION}`);
    layout.showStage();
    ctrl_timezone.init(kd);
    ctrl_func.init(kd);
    ctrl_location.init(kd);
    ctrl_chart.init(kd);
    if (kd.usage !== "embed") {
      modal.init(kd);
      ctrl_header.init(kd);
      ctrl_tabs.init(kd);
      ctrl_waitlist.init(kd);
      ctrl_reservation.init(kd);
      ctrl_noshows.init(kd);
      ctrl_resnoshows.init(kd);
      ctrl_precheck.init(kd);
      ctrl_seated.init(kd);
      ctrl_directseat.init(kd);
      ctrl_notes.init(kd);
      ctrl_stats.init(kd);
      ctrl_gestures.init(kd);
      ctrl_offline.init(kd);
      ctrl_keyboard.init(kd);
      print.init(kd);
      ctrl_wizard.init(kd);
      ctrl_android.init(kd);
    }
    ctrl_sections.init(kd);
    ctrl_filter.init(kd);
    ctrl_init.init(kd);
    ctrl_configuration.init(kd);
    ctrl_aux.init(kd);
  });
  ctrl_rpc.init(kd);
  ga(
    "send",
    "event",
    "usage",
    kd.usage,
    `/${kd.localstore.data.credentials.site_id}`
  );
  sleepWatch();
  overnight();
  ctrl_loading.complete(kd);
};

/**
 * Login / Usage path
 */

$(document).ready(() => {
  conf.init();
  ctrl_loading.start();
  ctrl_localization.init();
  let usage = ctrl_func.getQueryVar("usage");
  if (!usage) {
    usage = window.usage;
  }
  const embed_jwt =
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3d3dy5ndWVz" +
    "dGxpc3QuY29tIiwiaWF0IjoiMTUwMTYwODc5MSIsImV4cCI6IjIyNzkyMDg3OTEiLCJzaXRlIjoiaHR0c" +
    "HM6Ly93d3cuZ3Vlc3RsaXN0LmNvbS94eHh4Iiwic3ViIjoiaHR0cHM6Ly93d3cuZ3Vlc3RsaXN0LmNvbS" +
    "94eHh4Iiwic3Vic2NyaXB0aW9ucyI6WyJndWVzdGxpc3QiXSwic2l0ZV9pZCI6ImVtYmVkIiwidXNlcl9" +
    "pZCI6IjEwIiwiYWNjZXNzX2xldmVsIjoiMSIsImF1ZCI6ImNsaWVudC5zdGF0ZSIsImF1dGhvcml6ZWQi" +
    "OnRydWUsInZlcmlmaWVkIjp0cnVlfQ.ucztKE1lRb8xm3l8baIx713dMITEQs3S6iQsOPHNfEo";
  let site_id = 0;
  const xenial = {
    accessToken: "",
    companyID: "",
    floorPlanDocumentID: "",
    dmEnvironmentURL: "",
  };
  if (ctrl_func.getQueryVar("site_id")) {
    site_id = ctrl_func.getQueryVar("site_id");
  } else if (ctrl_func.getQueryVar("accessToken")) {
    xenial.accessToken = ctrl_func.getQueryVar("accessToken");
    xenial.companyID = xenialCompanyID(xenial.accessToken);
    xenial.floorPlanDocumentID = ctrl_func.getQueryVar("floorPlanDocumentID");
    xenial.dmEnvironmentURL = ctrl_func.getQueryVar("dmEnvironmentURL");
  }
  let language = "";
  if (ctrl_func.getQueryVar("language")) {
    language = ctrl_func.getQueryVar("language");
  } else if (window.localStorage.getItem("language")) {
    language = window.localStorage.getItem("language");
  }
  if (window.localStorage.getItem("interfaceSpeed")) {
    conf.vars.interfaceSpeed = Number(
      window.localStorage.getItem("interfaceSpeed")
    );
  }
  if (ctrl_func.getQueryVar("jwt")) {
    conf.vars.userdata = {
      jwtToken: ctrl_func.getQueryVar("jwt"),
      site_id: ctrl_func.getQueryVar("site_id"),
      language,
    };
  } else if (
    usage !== "embed" &&
    usage !== "x_chart" &&
    usage !== "x_section" &&
    usage !== "x_limit" &&
    window.localStorage.getItem("jwt") &&
    window.localStorage.getItem("lastLogin") &&
    Date.now() - window.localStorage.getItem("lastLogin") < 3 * 60 * 60 * 1000
  ) {
    usage = "resume";
    conf.vars.userdata = {
      jwtToken: window.localStorage.getItem("jwt"),
      site_id: window.localStorage.getItem("site_id"),
      language,
    };
  }
  if (
    conf.vars.NODE_ENV === "production" &&
    window.self === window.top &&
    usage &&
    usage.indexOf("_") > -1 &&
    usage.indexOf("g_") !== 0
  ) {
    window.localStorage.clear();
    window.location = conf.vars.APP_ROOT;
  }
  switch (usage) {
    case "embed": {
      kdclient
        .createClient(ctrl_connection.config(embed_jwt, "embed", "xenial"))
        .then((kdclientInst) => {
          kdclientInst.usage = usage;
          kdclientInst.mode = "xenial";
          layout.setUsage(usage, kdclientInst);
          configure(kdclientInst);
          login.block();
        });
      break;
    }
    case "resume": {
      ctrl_loading.resume();
      verifyJWT(conf.vars.userdata, (err, data) => {
        if (data.valid) {
          kdclient
            .createClient(
              ctrl_connection.config(
                conf.vars.userdata.jwtToken,
                conf.vars.userdata.site_id
              )
            )
            .then((kdclientInst) => {
              kdclientInst.usage = usage;
              kdclientInst.mode = "guestlist";
              configure(kdclientInst);
              login.block();
            });
        } else {
          window.location = conf.vars.APP_ROOT;
        }
      });
      break;
    }
    case "g_chart": {
      newTabCheck();
      verifyJWT(conf.vars.userdata, (err, data) => {
        if (data.valid) {
          ctrl_dashedit.header("loading...", 0, $(window).height());
          kdclient
            .createClient(
              ctrl_connection.config(
                ctrl_func.getQueryVar("jwt"),
                ctrl_func.getQueryVar("site_id")
              )
            )
            .then((kdclientInst) => {
              kdclientInst.usage = usage;
              kdclientInst.mode = "guestlist";
              configure(kdclientInst);
              login.block();
              setTimeout(() => {
                ctrl_configuration.chartOpen(kdclientInst);
                ctrl_dashedit.header(
                  ctrl_localization.translate("Seat Map Editor"),
                  1,
                  50
                );
              }, 2000);
            });
        }
      });
      break;
    }
    case "x_chart": {
      ctrl_dashedit.header("loading...", 0, $(window).height());
      kdclient
        .createClient(
          ctrl_connection.config(xenial.accessToken, xenial.companyID, "xenial")
        )
        .then((kdclientInst) => {
          kdclientInst.usage = usage;
          kdclientInst.mode = "xenial";
          kdclientInst.xenial = xenial;
          configure(kdclientInst);
          login.block();
          kd.getXConfig({}, (err, data) => {
            kd.emit("ready", {});
            ctrl_configuration.chartOpen(kdclientInst);
            ctrl_dashedit.header(
              ctrl_localization.translate("Seat Map Editor"),
              1,
              50
            );
          });
        });
      break;
    }
    case "g_section": {
      newTabCheck();
      verifyJWT(conf.vars.userdata, (err, data) => {
        if (data.valid) {
          ctrl_dashedit.header("loading...", 0, $(window).height());
          kdclient
            .createClient(
              ctrl_connection.config(
                ctrl_func.getQueryVar("jwt"),
                ctrl_func.getQueryVar("site_id")
              )
            )
            .then((kdclientInst) => {
              kdclientInst.usage = usage;
              kdclientInst.mode = "guestlist";
              configure(kdclientInst);
              login.block();
              setTimeout(() => {
                ctrl_configuration.sectionOpen(kdclientInst);
                ctrl_dashedit.header(
                  ctrl_localization.translate("Section Editor"),
                  1,
                  50
                );
              }, 2000);
            });
        }
      });
      break;
    }
    case "x_section": {
      ctrl_dashedit.header("loading...", 0, $(window).height());
      kdclient
        .createClient(
          ctrl_connection.config(xenial.accessToken, xenial.companyID, "xenial")
        )
        .then((kdclientInst) => {
          kdclientInst.usage = usage;
          kdclientInst.mode = "xenial";
          kdclientInst.xenial = xenial;
          configure(kdclientInst);
          login.block();
          kd.getXConfig({}, (err, data) => {
            kd.emit("ready", {});
            ctrl_configuration.sectionOpen(kdclientInst);
            ctrl_dashedit.header(
              ctrl_localization.translate("Section Editor"),
              1,
              50
            );
          });
        });
      break;
    }
    case "g_limit": {
      newTabCheck();
      verifyJWT(conf.vars.userdata, (err, data) => {
        if (data.valid) {
          ctrl_dashedit.header("loading...", 0, $(window).height());
          kdclient
            .createClient(
              ctrl_connection.config(
                ctrl_func.getQueryVar("jwt"),
                ctrl_func.getQueryVar("site_id")
              )
            )
            .then((kdclientInst) => {
              kdclientInst.usage = usage;
              kdclientInst.mode = "guestlist";
              configure(kdclientInst);
              login.block();
              setTimeout(() => {
                ctrl_configuration.limitOpen(kdclientInst);
                ctrl_dashedit.header(
                  ctrl_localization.translate("Reservation Limits"),
                  1,
                  50
                );
              }, 2000);
            });
        }
      });
      break;
    }
    case "x_limit": {
      ctrl_dashedit.header("loading...", 0, $(window).height());
      kdclient
        .createClient(
          ctrl_connection.config(xenial.accessToken, xenial.companyID, "xenial")
        )
        .then((kdclientInst) => {
          kdclientInst.usage = usage;
          kdclientInst.mode = "xenial";
          kdclientInst.xenial = xenial;
          configure(kdclientInst);
          login.block();
          kd.getXConfig({}, (err, data) => {
            kd.emit("ready", {});
            ctrl_configuration.limitOpen(kdclientInst);
            ctrl_dashedit.header(
              ctrl_localization.translate("Reservation Limits"),
              1,
              50
            );
          });
        });
      break;
    }
    default: {
      layout.showStage();
      login.init({}, (err, creds) => {
        login.check(creds, (err2, data) => {
          if (data.status === "valid") {
            if (
              data.hasOwnProperty("trialRemaining") &&
              data.trialRemaining < 0
            ) {
              const opt = {
                position: "top",
                width: "90%",
                seconds: 6,
                h1: "Your trial period has expired!",
                body:
                  "Please contact your dealer to get your account " +
                  "back into active status.",
                buttons: [
                  {
                    description: "ok",
                    value: "close",
                  },
                ],
              };
              notification.create(opt, {}, (err3, value2) => {
                notification.destroy();
              });
            } else {
              ga("send", "event", "login", "complete");
              conf.vars.userdata = Object.assign({}, data);
              conf.vars.userdata.language = language;
              window.localStorage.setItem("jwt", data.jwtToken);
              window.localStorage.setItem("site_id", data.site_id);
              window.localStorage.setItem("lastLogin", Date.now());
              kdclient
                .createClient(
                  ctrl_connection.config(data.jwtToken, data.site_id)
                )
                .then((kdclientInst) => {
                  kdclientInst.usage = "standard";
                  kdclientInst.mode = "guestlist";
                  configure(kdclientInst);
                  login.close();
                });
              if (
                data.hasOwnProperty("trialRemaining") &&
                data.trialRemaining <= 30
              ) {
                const opt = {
                  position: "top",
                  width: "90%",
                  seconds: 6,
                  h1: `Your trial has ${data.trialRemaining} days remaining`,
                  body:
                    "Please contact your dealer to get your account " +
                    "into paid status.",
                  buttons: [
                    {
                      description: "ok",
                      value: "close",
                    },
                  ],
                };
                notification.create(opt, {}, (err4, value2) => {
                  notification.destroy();
                });
              }
            }
          } else {
            login.shake();
          }
        });
      });
      break;
    }
  }
});

const newTabCheck = () => {
  if (
    ctrl_func.isMobile() &&
    $(window).width() <= 1024 &&
    $(window).height() <= 1024
  ) {
    $("#dashboard_header_popout").css("visibility", "visible");
    $('meta[name="viewport"]').attr(
      "content",
      "width=device-width, user-scalable=no, " +
        "initial-scale=0.8, maximum-scale=1.5, minimum-scale=0.8, viewport-fit=cover"
    );
  }
};

const onResume = () => {
  ctrl_loading.resume();
  let loc = xss(window.location.href).split("?")[0];
  if (loc.indexOf("/#") > -1) {
    loc = `${loc.split("/#")[0]}/`;
  }
  window.location = loc;
};

const sleepWatch = () => {
  document.addEventListener("visibilitychange", () => {
    if (ctrl_func.isMobile() && !document.hidden) {
      // onResume();
    }
  });
  document.addEventListener("resume", onResume, false);
};

const overnight = () => {
  schedule.scheduleJob("0 2 * * *", () => {
    let loc = xss(window.location.href).split("?")[0];
    if (loc.indexOf("/#") > -1) {
      loc = `${loc.split("/#")[0]}/`;
    }
    window.location = loc;
  });
};

const verifyJWT = (udata, callback) => {
  console.log("verifying jwt");
  $.ajax({
    url: `${conf.vars.API_ROOT}/jwt`,
    type: "POST",
    data: JSON.stringify(udata),
    contentType: "application/json",
    success: (result) => {
      callback(null, result);
    },
    error: (jqXHR, textStatus, errorThrown) => {
      console.log(errorThrown);
    },
    timeout: 10000,
  });
};

module.exports = {
  configure,
};



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/